var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawWarningTl76(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 774.305,
    height: 799.978,
    viewBox: "0 0 774.305 799.978",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-480.785 -126.107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M372.058,436.637c-.054,1.211-.436,2.052-.837,2.052H.828c-.389,0-.75-.816-.812-1.988-.08-1.5.3-2.791.775-2.791H371.283C371.752,433.91,372.125,435.159,372.058,436.637Z",
    transform: "translate(883.025 476.924)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.243,
    cy: 6.243,
    r: 6.243,
    transform: "translate(610.472 143.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.243,
    cy: 6.243,
    r: 6.243,
    transform: "translate(634.171 143.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.243,
    cy: 6.243,
    r: 6.243,
    transform: "translate(657.865 143.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(979.538 393.873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.3,427.631l-7.171,50.991L252.856,532.8c-8.769,7.967-.8,27.09-.8,27.09l7.966-5.574,1.594-9.561s35.057-39.837,43.821-49.4,11.952-62.145,11.952-62.145Z",
    transform: "translate(-172.367 -302.527)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.32,718.909s-1.594,18.325-.8,23.105,24.7-.8,24.7-.8c-3.984-7.967-6.375-31.869-6.375-31.869Z",
    transform: "translate(-85.997 -248.008)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.191,721.752s-2.39,25.5-1.594,30.276,24.7-.8,24.7-.8c-3.984-7.967-6.375-31.87-6.375-31.87Z",
    transform: "translate(-305.585 -246.069)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.979,
    cy: 28.979,
    rx: 28.979,
    ry: 28.979,
    transform: "translate(45.453 8.996)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.4,381.062c4.781,6.375,2.39,17.529,2.39,17.529s48.6,56.575,57.366,56.575,7.171-39.838,7.171-39.838S310.576,400.194,303.405,397s-19.919-37.447-19.919-37.447S251.616,374.687,256.4,381.062Z",
    transform: "translate(-186.968 -315.7)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.172,468.362l-31.187,52.389c-5.691,9.365,4.9,56.765,4.9,56.765L241.661,678.7l7.967,101.957v11.154l26.292-.8,8.769-109.128,12.748-82.064,20.715,62.94,34.259,77.283a211.817,211.817,0,0,0,10.758,27.873l6.375,11.154,23.9-2.793L357.194,654l-7.17-79.671c-.8-44.617-15.134-69.316-15.134-69.316v-9.561Z",
    transform: "translate(-226.411 -294.644)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.644,734.114s-3.984-6.375-3.984-3.984S232.3,738.9,232.3,738.9s-10.358-1.594-11.952,10.358S234.692,763.6,238.675,762.8s14.342.8,14.342.8a71.1,71.1,0,0,0,20.715,0c12.748-1.594,1.594-23.105,0-27.09s-9.561-.8-9.561-.8C249.831,739.69,246.644,734.114,246.644,734.114Z",
    transform: "translate(-100.728 -244.09)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.777,744.124s-3.984-6.373-3.984-3.984-10.358,8.769-10.358,8.769-10.358-1.594-11.952,10.358,14.342,14.342,18.325,13.544,14.342.8,14.342.8a71.1,71.1,0,0,0,20.715,0c12.748-1.594,1.594-23.105,0-27.09s-9.561-.8-9.561-.8C349.964,749.7,346.777,744.124,346.777,744.124Z",
    transform: "translate(-320.372 -242.154)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.259,392.387c-19.919-20.715-41.43,31.073-41.43,31.073s-7.171,19.122-1.594,29.48-5.577,33.463-5.577,33.463c27.285,23.227,54.475,44.695,79.674,29.48-3.187-19.122,7.171-28.682,14.342-47.007s20.715-14.342,20.715-14.342-.8-20.715-3.187-37.447-23.9-23.013-23.9-23.013C330.4,401.08,315.178,413.1,295.259,392.387Z",
    transform: "translate(-213.878 -310.294)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.3,419.631l-7.171,50.991L312.856,524.8c-8.769,7.967-.8,27.09-.8,27.09l7.966-5.574,1.594-9.561s35.057-39.838,43.821-49.4,11.952-62.145,11.952-62.145Z",
    transform: "translate(-303.982 -304.076)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.933,434.238l33.463,3.984s2.39-39.037-2.663-48.8-23.63.99-23.63.99C309.324,391.214,306.933,434.238,306.933,434.238Z",
    transform: "translate(-265.391 -310.715)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.567,344.011c21.431,10.711,9.066,39.956,11.6,52.227,4.143,20.1,65.236,9.885,65.236,9.885,7.433-1.337,11.963-84.033-28.743-83.307C294.137,323.188,279.94,329.7,266.567,344.011Z",
    transform: "translate(-224.577 -322.812)",
    fill: "#090814"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480.785 126.107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.949,579.206l-296.571.1A41.125,41.125,0,0,1,75.665,517.5L223.856,247.726a41.215,41.215,0,0,1,71.386-.025l148.4,269.7a41.214,41.214,0,0,1-35.69,61.8h0ZM73.813,538.1c0,6.442,32.725-7.44,36.115-1.572,6.782,11.736-12.107,39.062,1.448,39.057,0,0,322.261-7.12,329.035-18.861a37.111,37.111,0,0,0-.014-37.495L292,249.529a37.1,37.1,0,0,0-32.458-18.7c-13.549,0-185.729,300.833-185.73,307.277h0Z",
    transform: "translate(-70.085 -227.107)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93.908 110.78)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 103.25,
    cy: 103.25,
    r: 103.25,
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.347,7.97,12.264-83.3H30.682L29.508,7.97Zm8.216,38.255a11.746,11.746,0,0,1-8.622-3.566,12.1,12.1,0,0,1,0-17.154,11.746,11.746,0,0,1,8.622-3.566,11.6,11.6,0,0,1,8.577,3.566,11.822,11.822,0,0,1,3.521,8.622A11.716,11.716,0,0,1,30.14,42.66,11.6,11.6,0,0,1,21.563,46.226Z",
    transform: "translate(81.734 121.789)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawWarningTl76);
export default __webpack_public_path__ + "static/media/undraw_warning_tl76.7a70606db6f0339cdb9ba7dcdeb74975.svg";
export { ForwardRef as ReactComponent };